'use es6';

import PropTypes from 'prop-types';
import createChainablePropType from './createChainablePropType';
export const getComponentPropType = ({
  propTypes,
  defaultProps
}) => {
  return createChainablePropType(PropTypes.elementType, 'componentProp', {
    propTypes,
    defaultProps
  });
};
export const isRenderable = children => children != null && children !== false;